import Oidc from 'oidc-client'
import stores from '../store/index'

if (!window.env || !window.env.VUE_APP_COGNITO_URL) {
  console.error("Cognito URL is not set. Please check the environment variables.");
} else {
  var mgr = new Oidc.UserManager({
    userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
    authority: window.env.VUE_APP_COGNITO_URL,
    client_id: window.env.VUE_APP_COGNITO_CLIENT_ID,
    redirect_uri: window.env.VUE_APP_URL,
    // silentRefreshRedirectUri:window.env.VUE_APP_URL,
    response_type: 'code',
    scope: 'openid profile',
    post_logout_redirect_uri: window.env.VUE_APP_URL + '/login',
    automaticSilentRenew: true,
    revokeAccessTokenOnSignout: true,
    includeIdTokenInSilentRenew: true,
    monitorSession: true,
    silent_redirect_uri: window.env.VUE_APP_URL,
    metadata: {
      token_endpoint: window.env.VUE_APP_COGNITO_URL + '/oauth2/token',
      issuer: window.env.VUE_APP_COGNITO_USER_POOL,
      authorization_endpoint: window.env.VUE_APP_COGNITO_URL + '/oauth2/authorize',
      userinfo_endpoint: window.env.VUE_APP_COGNITO_URL + '/oauth2/userInfo',
      jwks_uri: window.env.VUE_APP_COGNITO_USER_POOL + '/.well-known/jwks.json',
      end_session_endpoint: window.env.VUE_APP_URL + '/login'
    }
  })
}

Oidc.Log.logger = console
Oidc.Log.level = Oidc.Log.INFO

mgr.events.addAccessTokenExpired(function () {
  // alert('Your session is expired. Please re-authenticate.')
  mgr.removeUser().then(function (resp) {
    stores.dispatch('userStore/logOut')
    console.log('user removed', resp)
    window.localStorage.clear()
    window.sessionStorage.clear()
    mgr.signoutRedirect().then(function (resp) {
      console.log('signed out', resp)
    }).catch(function (err) {
      console.log(err)
    })
  }).catch(function (err) {
    console.log(err)
  })
})

mgr.events.addAccessTokenExpiring(async function () {
  await AuthService.renewToken()
  await stores.dispatch('userStore/loadTokenId')
  await stores.dispatch('userStore/loadToken')
})

// When user session has been established (or re-established)
mgr.events.addUserLoaded(args => {
  mgr.signinSilentCallback()
     .catch((err) => {
      console.log(err)
    })
  mgr.getUser().then(async user => {
    await stores.dispatch('userStore/loadTokenId')
    await stores.dispatch('userStore/loadToken')

    stores.commit('userStore/clearUserInfo')

    // Immediately fetch the new info so the UI updates instantly
    await stores.dispatch('userStore/loadUserInfo')
  })
})

export const AuthService = {
  mgr: mgr,
  signIn () {
    mgr.signinRedirect().catch(function (err) {
      console.log(err)
    })
  },
  getAccessToken () {
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user !== null) {
          return resolve(user.access_token)
        } else {
          return resolve('')
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      })
    })
  },
  getIdToken () {
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user !== null) {
          return resolve(user.id_token)
        } else {
          return resolve('')
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      })
    })
  },
  signOut () {
    mgr.removeUser().then(function (resp) {
      stores.dispatch('userStore/logOut')
      console.log('user removed', resp)
      window.localStorage.clear()
      window.sessionStorage.clear()
      mgr.signoutRedirect().then(function (resp) {
        console.log('signed out', resp)
      }).catch(function (err) {
        console.log(err)
      })
    }).catch(function (err) {
      console.log(err)
    })
  },
  getSignedIn () {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        //mgr.signinSilent()
        mgr.startSilentRenew()
        if (user == null) {
          self.signIn()
          return resolve(false)
        } else {
          return resolve(true)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      })
    })
  },
  renewToken () {
    return new Promise((resolve, reject) => {
      mgr.signinSilent().then(function (user) {
        if (user !== null) {
          return resolve(user)
        } else {
          return resolve(null)
        }
      }).catch(function (err) {
        console.log(err)
        return reject(err)
      })
    })
  }
}

// To test token renewal:
// Uncomment this:
//window.TEST_AUTH = AuthService;
// From the browser console, call:
//window.TEST_AUTH.renewToken();
